import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="social-embeds--facebook"
export default class extends Controller {
  static values = { appId: String };

  static targets = [ "embed", "fallback"];

  connect() {
    this.embedObserver = new MutationObserver(() => this.useStandaloneLinks());
    this.embedObserver.observe(this.embedTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    });
    this.useStandaloneLinks();
    this.fallbackIfNotEmbeddable();
    this.loadFacebookSDK();
  }

  disconnect() {
    this.embedObserver.disconnect();
  }

  loadFacebookSDK() {
    if (window.FB) {
      // SDK is already loaded, just reinitialize
      this.reparse();
      return;
    }

    if (document.getElementById("facebook-jssdk")) return; // Avoid multiple loads

    let script = document.createElement("script");
    script.id = "facebook-jssdk";
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;

    script.onload = () => {
      window.FB.init({
        appId: this.appIdValue || "", // Use the appId from data attribute
        autoLogAppEvents: true,
        xfbml: true,
        version: "v22.0",
      });

      this.reparse();
    };

    document.body.appendChild(script);
  }

  reparse() {
    if (!window.FB || !this.element.isConnected) return;

    window.FB.XFBML.parse(this.element);
  }

  useStandaloneLinks() {
    const iframe = this.embedTarget.querySelector("iframe");
    if (!iframe || iframe.style.visibility !== "visible") return;

    // SDK mode makes "See more" navigate inside the iframe. Switch to
    // standalone links after the SDK has finished sizing the widget.
    const url = new URL(iframe.src);
    if (!url.searchParams.has("sdk")) return;

    url.searchParams.delete("sdk");
    iframe.src = url.toString();
  }

  fallbackIfNotEmbeddable() {
    const checkPath = `/public/feeds_v2/facebook_posts/embed_check?url=${this.facebookPostUrl()}`;

    // Do a GET request to the embeddableCheckPath and return true if the response is 200
    fetch(checkPath, { method: "GET" })
      .then((response) => {
        if (response.ok) {
          // Do nothing, the SDK is embeddable
        } else {
          console.warn("Facebook SDK not embeddable in this environment.");
          // Hide the embed and show the fallback
          this.embedTarget.classList.add("d-none");
          this.fallbackTarget.classList.remove("d-none");
        }
      })
      .catch((error) => {
        console.error("Error checking embeddable status:", error);
      });
  }

  facebookPostUrl() {
    return this.embedTarget.dataset.href;
  }
}
